/* eslint-disable react/forbid-dom-props, react/forbid-component-props */
import classnames from 'classnames';
import { isEqual, isNil } from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import withWindowScroll from '../../../../utils/withWindowScroll';
import FormControlErrorMessage from '../../../utils/FormControlErrorMessage';
import FormControlInfoMessage from '../../../utils/FormControlInfoMessage';
import AnimatedTitle from '../AnimatedTitle';
import styles from './SelectBox.scss';
import SelectBoxMenu from './SelectBoxMenu';
import SelectedBoxButton from './SelectedBoxButton';
import useLayoutDirection from '../../../utils/Translations/useLayoutDirection';
export const RETURN_TYPE = {
    NUMBER: 'number',
    STRING: 'string',
    OPTION: 'option',
};
const SelectBox = (props) => {
    const { direction } = useLayoutDirection();
    const { containerStyle, isFilterBar = false, returnType = RETURN_TYPE.STRING, placeholder = '', title = '', tooltipTitle = '', value: selectedValue = '', emptyValue: baseEmptyValue = '', required = false, itemValuePropName = 'value', hasGroupNameInTitle = false, groupTitleKeys = null, options = [], infoMessageAlign = 'right', onChangeQuery = null, loading = false, errorMessage = null, infoMessage = null, formElement = false, dropup, withTitle = true, containerClassNames = '', onRenderSelected, listComponent, hasBottomMargin, isInTable, searchInputClassName, searchInputWidthClassName, menuClassName, labelRequired = true, } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const controlRef = useRef(null);
    const containerRef = useRef(null);
    const classByReturnType = useMemo(() => {
        switch (returnType) {
            case RETURN_TYPE.STRING:
                return String;
            case RETURN_TYPE.NUMBER:
                return Number;
            case RETURN_TYPE.OPTION:
                return value => value;
            default:
                return () => null;
        }
    }, [returnType]);
    const isValueOk = useCallback(value => {
        if (returnType === RETURN_TYPE.NUMBER) {
            return value || value === 0;
        }
        if (returnType === RETURN_TYPE.STRING) {
            return value || value === '';
        }
        return !!value;
    }, [returnType]);
    const getItemValue = useCallback(item => returnType === RETURN_TYPE.OPTION ? item : item[itemValuePropName], [itemValuePropName, returnType]);
    const addGroupName = useCallback((item, groupIndex) => {
        const groupName = groupTitleKeys && groupTitleKeys[groupIndex];
        return groupName && hasGroupNameInTitle ? { ...item, groupName } : item;
    }, [groupTitleKeys, hasGroupNameInTitle]);
    const comparator = useCallback((toCompare, value) => value !== baseEmptyValue &&
        (isEqual(classByReturnType(value), classByReturnType(toCompare)) ||
            (isNil(toCompare) && isNil(value))), [baseEmptyValue, classByReturnType]);
    const findOptionByValue = useCallback(value => {
        if (!classByReturnType || !options) {
            return { option: null };
        }
        for (const group of options) {
            if (Array.isArray(group)) {
                for (const option of group) {
                    if (comparator(getItemValue(option), value)) {
                        return { option, index: options.indexOf(group) };
                    }
                }
            }
            else {
                if (comparator(getItemValue(group), value)) {
                    return { option: group };
                }
            }
        }
        return { option: null };
    }, [classByReturnType, comparator, getItemValue, options]);
    const handleInputChange = useCallback(search => {
        setSearch(search);
        onChangeQuery && onChangeQuery(search);
    }, [onChangeQuery]);
    const handleSearchReset = useCallback(() => handleInputChange(''), [
        handleInputChange,
    ]);
    const closeMenu = useCallback(() => {
        if (isOpen) {
            handleSearchReset();
        }
        setIsOpen(false);
    }, [handleSearchReset, isOpen]);
    const { selectedItem, groupIndex } = useMemo(() => {
        if (isValueOk(selectedValue)) {
            const { option, index } = findOptionByValue(selectedValue);
            return { selectedItem: option, groupIndex: index };
        }
        return {};
    }, [findOptionByValue, isValueOk, selectedValue]);
    const containerClass = useMemo(() => classnames('form-group-material select-picker-wrapper', containerClassNames, {
        'form-group': formElement,
        'select-placeholder': !isValueOk(selectedItem),
    }), [formElement, isValueOk, selectedItem, containerClassNames]);
    const selectClass = useMemo(() => classnames('btn-group bootstrap-select form-control select-title', {
        open: isOpen,
        dropup,
        [styles.filterBarStyle]: isFilterBar,
    }), [dropup, isFilterBar, isOpen]);
    useEffect(() => {
        if (options.every(item => item.hasOwnProperty('orgGroupId')) &&
            selectedValue) {
            localStorage.setItem('organisationId', selectedValue);
        }
    }, [selectedValue]);
    const ListComponent = listComponent || SelectBoxMenu;
    const selectedTitle = tooltipTitle || title;
    return (<div ref={containerRef} className={containerClass} data-layout-direction={direction} dir={direction} style={containerStyle}>
      {!withTitle || isFilterBar ? null : (<AnimatedTitle isRequired={labelRequired && required} placeholder={placeholder} tooltipTitle={tooltipTitle} value={isValueOk(selectedItem) && !loading}/>)}

      <div className={selectClass}>
        <SelectedBoxButton addGroupName={addGroupName} controlRef={controlRef} groupIndex={groupIndex} isOpen={isOpen} isValueOk={isValueOk} props={props} selectedItem={selectedItem} setIsOpen={setIsOpen} setSearch={setSearch} title={selectedTitle} onRenderSelected={onRenderSelected}/>
        {isOpen ? (<ListComponent addGroupName={addGroupName} closeMenu={closeMenu} comparator={comparator} containerRef={containerRef} controlRef={controlRef} findOptionByValue={findOptionByValue} hasBottomMargin={hasBottomMargin} isInTable={isInTable} isOpen={isOpen} isValueOk={isValueOk} menuClassName={menuClassName} props={props} search={search} searchInputClassName={searchInputClassName} searchInputWidthClassName={searchInputWidthClassName} setSearch={setSearch}/>) : null}
      </div>

      {infoMessage && (<FormControlInfoMessage message={infoMessage} messageAlign={infoMessageAlign}/>)}
      {errorMessage && <FormControlErrorMessage errorMessage={errorMessage}/>}
    </div>);
};
SelectBox.returnType = RETURN_TYPE;
export default withWindowScroll(SelectBox);
